import { Typography, Paper } from "@mui/material";
import PropTypes from "prop-types";

function SectionBox({ title, children }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5, // ✅ Padding interno más compacto
        mb: 1.5, // ✅ Menor margen inferior entre secciones
        borderRadius: 1.5, // Estética suave
      }}
    >
      <Typography
        variant="subtitle2" // ✅ Más grande que body2, más pequeña que subtitle1
        sx={{
          fontWeight: 600,
          fontSize: "1rem", // ✅ Aumenta un poco la legibilidad
          mb: 1.5,
        }}
      >
        {title}
      </Typography>
      {children}
    </Paper>
  );
}

SectionBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default SectionBox;
